/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  InputWrapper,
  StyledInput,
  CharacterCount,
} from './styles/CustomInputStyles';

/**
 * テキスト入力コンポーネント。
 * 文字数制限を設定し、現在の文字数と最大文字数を表示する。
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.id - 入力フィールドのID
 * @param {string} [props.value] - 入力フィールドの現在の値（制御されたコンポーネント用）
 * @param {string} [props.defaultValue] - 入力フィールドのデフォルト値（非制御コンポーネント用）
 * @param {string} props.placeholder - プレースホルダーテキスト
 * @param {Function} props.onChange - 値が変更されたときに呼び出される関数
 * @param {number} [props.maxLength] - 入力可能な最大文字数（オプショナル）
 * @param {Object} [props.register] - React Hook Form の register オブジェクト
 */
const CustomInput = ({
  id,
  value,
  defaultValue,
  placeholder,
  onChange,
  maxLength,
  register,
}) => (
  <InputWrapper>
    <StyledInput
      id={id}
      type="text"
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      onChange={onChange}
      maxLength={maxLength}
      {...register}
    />
    {maxLength && (
      <CharacterCount>{`${value.length}/${maxLength}`}</CharacterCount>
    )}
  </InputWrapper>
);

CustomInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  maxLength: PropTypes.number,
  register: PropTypes.any,
};

CustomInput.defaultProps = {
  maxLength: undefined,
  register: undefined,
};

export default CustomInput;
